module.exports = __webpack_public_path__ + "static/3_3-755d9689f0aefca818f9e1f58fccdc8c.jpeg";